export const QuestionType = Object.freeze({
    SINGLE_SELECTION: 'SINGLE_SELECTION',
    MULTIPLE_SELECTION: 'MULTIPLE_SELECTION',
    FREE_TEXT: 'FREE_TEXT',
    FILL_IN_THE_BLANKS: 'FILL_IN_THE_BLANKS',
    ORDERING_ELEMENTS: 'ORDERING_ELEMENTS',
    MATCHING_ELEMENTS: 'MATCHING_ELEMENTS'
});